<template>
  <div class="container-fluid">
    <template v-if="documentsAdded.length > 0 ">
      <template v-for="(item, index) in documentsAdded">
        <div :key="index">
          <div class="row p-2 m-2 container-doc">
            <div class="col-md-4 col-sm-12 mt-2">
              <CustomInputDisplay
                v-model="item.documentType.name"
                label="Tipo de documento:"
                label-class="label-small"
              />
            </div>

            <div class="col-md-4 col-sm-12 mt-2">
              <CustomInputDisplay
                v-model="item.documentName"
                label="Archivo:"
                label-class="label-small"
              />
            </div>

            <div v-if="!isMobile" class="col-md-4 col-sm-12 mt-2">
              <div class="align-button">
                <DropDown :items="getActions(item)" title="Acciones" />
              </div>
            </div>
            <div class="col-12" v-if="!isValidMiunteDate(item.meetingDate)">
              <ErrorComponent
                class="px-3"
                message="El documento seleccionado no corresponde con la fecha de la discusión"
                :is-borderless="true"
              />
            </div>
          </div>
        </div>
      </template>
    </template>

    <template v-if="showUploadPanel">
      <div
        class="d-flex container-document-button pl-3 pr-3 pb-3 pt-0 wrap-upload-panel"
      >
        <div class="bg-white p-2 upload-panel-container">
          <div class="row mt-2 px-2">
            <div class="col-md-3 col-sm-12">
              <template v-if="editableDocument">
                <CustomInputDisplay
                  v-model="file.documentType.name"
                  label="Tipo de documento:"
                  label-class="label-small"
                />
              </template>

              <template v-else>
                <ValidationProvider
                  ref="documentTypeValidator"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <CustomDropDown
                    id="ddlTypeSelected"
                    v-model="file.documentType"
                    label="Tipo de documento:"
                    class="custom-dropDown-label"
                    placeholder="Seleccione"
                    required="required"
                    fieldkey="id"
                    fieldname="name"
                    :options="availableDocumentTypes"
                    :error="errors[0]"
                    custom-error-msg="El tipo de documento es requerido."
                  />
                </ValidationProvider>
              </template>
            </div>

            <div class="col-md-9 col-sm-12" v-if="file.documentType">
              <div v-if="isMinuteDocumentType && isCompuMinuteSystemSelectionEnabled">
                <CompuMinuteSelection
                  :value="file"
                  :student-sie-id="studentSieId"
                  ref="compuMinuteSelection"
                  :on-go-to-draft-minute="goToDraftMinute"
                  @input="onMinuteInputChange"
                  @delete="onMinuteDelete"
                  @selected-minute-changed="selectedMinute = $event"
                />
                <ErrorComponent
                  v-if="!isValidMiunteDate(selectedMinute?.meetingDate)"
                  class="px-3"
                  message="El documento seleccionado no corresponde con la fecha de la discusión"
                  :is-borderless="true"
                />
              </div>

              <div
                class="container-upload-document"
                v-if="!isCompuMinuteSystemSelectionEnabled || file.useSystemMinute === false || !isMinuteDocumentType"
              >
                <ValidationProvider
                  ref="documentValidator"
                  v-slot="{ errors }"
                  name="Documento"
                  rules="required"
                >
                  <CustomFileInput
                    :key="fileKey"
                    id="txtFileAttachment"
                    ref="fileUpload"
                    v-model="file.attachment"
                    class="custom-fileInput-label"
                    label="Archivo:"
                    required
                    :accept="'.pdf'"
                    display-style="normal"
                    label-position="left"
                    :error="errors[0]"
                    :add-text="'Presione aquí para añadir documento'"
                    custom-error-msg="El documento es requerido."
                    :on-download="downloadDocument"
                    :is-edit="editableDocument"
                    @after-remove="toggleEdit"
                  />
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div v-if="isMobile" class="row px-10 pb-2 resizer">
            <div class="col-6 text-right pb-3">
              <ActionButton
                id="btnCancel"
                variant="outline-danger mr-2 btn-block"
                type="button"
                i="fas fa-times-circle"
                @click="onCancelHandler"
              >
                Cancelar
              </ActionButton>
            </div>

            <div class="col-6 text-right">
              <template v-if="editMode">
                <ActionButton
                  id="btnEditEvaluation"
                  variant="success btn-block"
                  i="fas fa-save text-end"
                  @click="onEditDocumentHandler"
                >
                  Guardar
                </ActionButton>
              </template>

              <template v-else>
                <ActionButton
                  id="btnAddEvaluation"
                  variant="success btn-block"
                  i="fas fa-file-plus text-end"
                  @click="onAddDocumentHandler"
                >
                  Añadir
                </ActionButton>
              </template>
            </div>
          </div>
          <div v-if="!isMobile" class="row px-10 pb-2 resizer">
            <div class="col-12 text-right pb-3">
              <ActionButton
                id="btnCancel"
                variant="outline-danger mr-2 "
                type="button"
                i="fas fa-times-circle"
                @click="onCancelHandler"
              >
                Cancelar
              </ActionButton>
              <template v-if="editMode">
                <ActionButton
                  id="btnEditEvaluation"
                  variant="success "
                  i="fas fa-save text-end"
                  @click="onEditDocumentHandler"
                >
                  Guardar
                </ActionButton>
              </template>

              <template v-else>
                <ActionButton
                  id="btnAddEvaluation"
                  variant="success "
                  i="fas fa-file-plus text-end"
                  @click="onAddDocumentHandler"
                >
                  Añadir
                </ActionButton>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="!showUploadPanel && documentsAdded.length == 0">
      <div class="row justify-content-center container-document-button">
        <div class="col-md-12 col-sm-12 text-center">
          <div class="d-flex" style="background-color: #fafafa">
            <ActionButton
              v-if="!isSubmitted"
              id="activationBtnShowUploadPanel"
              type="activationButton"
              text="Presione aquí para anejar documento"
              @click="onShowUploadPanel"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="!showUploadPanel && documentsAdded.length > 0 && currentDocuments.length==0 ">
      <div class="row my-2 mt-5">
        <div class="col-md-12 col-sm-12 text-right">
          <ActionButton
            v-if="!isSubmitted"
            id="btnShowUploadPanel"
            variant="success"
            i="fas fa-file-plus text-end"
            @click="onShowUploadPanel"
          >
            Añadir
          </ActionButton>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import CustomFileInput from "CustomFileInput";
import CustomDropDown from "custom-drop-down";
import CustomChipsGroup from "CustomChipsGroup";
import CustomInputDisplay from "CustomInputDisplay";
import DropDown from "dropdown";
import CustomError from "custom-error";
import ErrorComponent from "@/components/common/Error";
import alert from "@/mixin/alert.mixin";
import documentsService from "@/services/documents";
import { getAnalysisDocumentTypes } from "@/modules/common/code.api.js";
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";
import CompuMinuteSelection from "@/components/shared/CompuMinuteSelection.vue";
import compuMinuteService from "@/modules/compu-minutes-editor/api";

const DocumentTypes = Object.freeze({
  Minuta: 1876,
  Otros: 67,
});

export default {
  name: "EvaluationDocuments",
  mixins: [alert],
  components: {
    ActionButton,
    CustomFileInput,
    CustomDropDown,
    CustomChipsGroup,
    CustomInputDisplay,
    DropDown,
    CustomError,
    ErrorComponent,
    CompuMinuteSelection,
  },
  props: {
    currentDocuments: {
      type: Array,
      default: () => [],
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    studentSieId: {
      type: [Number, String],
      default: null,
    },
    evaluationDate: {
      type: Date,
      default: null,
    }
  },
  data() {
    return {
      showUploadPanel: false,
      editableDocument: false,
      editMode: false,
      validateEvaluationOptions: true,
      documentsAdded:[],
      file: {
        type: null,
        attachment: null,
        documentType: null,
        useSystemMinute: null,
        compuMinuteId: null,
        fileId: null,
        fileName: null,
      },
      collections: {
        documentTypes: [],
      },
      selectedMinute: null,
      sysParameters: [],
      fileKey: 0,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    isCompuMinuteSystemSelectionEnabled() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'ActiveCompuMinuteSystemSelection'
      );
      return obj?.staticValue?.toLowerCase() === 'true' ?? false;
    },
    isMinuteDocumentType() {
      return this.file.documentType?.id === DocumentTypes.Minuta;
    },
  },
    methods: {
      mapDocumentToDto() {
        const dto = {
          id: this.editingDocumentId || Date.now() + Math.random(), // ID existente o nuevo
          documentType: this.file.documentType,
          documentTypeId: this.file.documentType.id,
          documentName: !!this.file.useSystemMinute ? this.file.fileName : this.file.attachment?.name ?? null,
          attachment: !!this.file.useSystemMinute ? null : this.file.attachment,
          evaluations: [...this.addedEvaluations],
          compuMinuteId: !!this.file.useSystemMinute ? this.file.compuMinuteId : null,
          fileId: !!this.file.useSystemMinute ? this.file.fileId : null,
          useSystemMinute: this.file.useSystemMinute,
          meetingDate: this.selectedMinute?.meetingDate ?? null,
        };

        return dto;
      },
        async getDocumentTypes() {
            const { data } = await getAnalysisDocumentTypes();
            this.collections.documentTypes = [...data];
        },
        getActions(item) {
            let actions = [
                {
                    label: "Descargar",
                    icon: "fas fa-file-download text-green",
                    border: "none",
                    click: () => {
                        this.downloadDocument(item);
                    },
                },
                {
                    label: "Eliminar",
                    icon: "fas fa-times-circle text-red",
                    visible: !this.isSubmitted,
                    border: "none",
                    click: () => {
                        this.removeDocument(item);
                    },
                },
            ];
            return actions;
        },
        async gettingBackupDocument(data) {
            this.backupDocument.data = data;
        },
        async onAddEvaluationHandler() {
            const { valid } = await this.$refs.evaluationValidator.validate();

            if (valid) {
                const evaluationItem = {
                ...this.selectedEvaluation,
                };

                this.addedEvaluations.push(evaluationItem);

                this.selectedEvaluation = null;
            }
        },
        onRemoveEvaluationHandler(item) {
        const filteredAddedEvaluations = this.addedEvaluations.filter(
            (x) => x.id != item.id
        );

        this.addedEvaluations = [...filteredAddedEvaluations];
        },
        async onCancelHandler() {
            this.file.documentType = null;
            this.file.attachment = null;
            this.selectedEvaluation = null;
            this.addedEvaluations = [];
            this.noEvaluationsAdded = false;

            await this.$nextTick(() => {
                this.$refs.fileUpload.file = null;
                this.$refs.fileUpload.fileLabel = null;
            });

            this.editableDocument = false;
            this.showUploadPanel = false;
            this.selectedMinute = null;
        },
        async validateForm() {
            const validDocumentType = this.editableDocument
                ? { valid: true }
                : await this.$refs.documentTypeValidator.validate();
            const validDocument = await this.$refs.documentValidator?.validate() ?? { valid: true };
            const validMinuteSelection = await this.$refs.compuMinuteSelection?.validate() ?? true;

            return (
                validDocumentType.valid &&
                validDocument.valid &&
                validMinuteSelection);
        },
        async onAddDocumentHandler() {
            const valid = await this.validateForm();
            if (!valid || !this.isValidMiunteDate(this.selectedMinute?.meetingDate)) return;

            let dataToSend=[]
            this.documentsAdded.forEach((element) => {
              dataToSend.push({...element})
            })

            const dto = this.mapDocumentToDto();
            dataToSend.push(dto)
            this.documentsAdded.push(dto)
            this.$emit("on-add-document", dataToSend);
            this.setEmptyDocument();
            this.selectedMinute = null;
        },
        onShowUploadPanel() {
            this.showUploadPanel = !this.showUploadPanel;

            const filtered = this.collections.documentTypes.filter(
                (x) =>
                !this.currentDocuments.some(
                    (obj) => obj.documentType.id == x.id && x.id !== DocumentTypes.Otros
                )
            );

            this.availableDocumentTypes = [...filtered];
        },
        async onEditDocumentHandler() {
            const valid = await this.validateForm();
            if (!valid || !this.isValidMiunteDate(this.selectedMinute?.meetingDate)) return;

            const dto = this.mapDocumentToDto();
            this.$emit("on-edit-document", dto);

            this.onCancelHandler(); //Clear fields
        },
        async downloadDocument(item) {
            const documentId = item.documentId ?? item.documentAttachmentId;
            if (documentId) {
                documentsService.downloadDocumentByAttachmentIdOrDocumentId(documentId);
            }
            else if(!!item.fileId) {
                documentsService.downloadDocumentByAttachmentIdOrDocumentId(item.fileId);
            } else {
                let file = {
                filename: item.documentName || item.name,
                content: item.attachment || item,
                contentType: "application/pdf",
                };
                documentsService.downloadFile(file);
            }
        },
        toggleEdit() {
            if (this.editableDocument) {
                this.editableDocument = false;
            }
        },
        async removeDocument(item) {
            const res = await this.ShowCancelModal(
                "Alerta",
                `¿Está seguro que desea eliminar el documento ${item.documentName}?`,
                "Sí",
                "No"
            );

            if (res) {
                const filtered = this.documentsAdded.filter(
                x => x.id != item.id
            );

            let dataToSend=[]
            this.documentsAdded.forEach((element)=>{
                dataToSend.push({
                    documentTypeId: element.documentTypeId,
                    documentName:element.documentName,
                    attachment: element.attachment,
                })
            })
            this.$emit("on-add-document", dataToSend);

            this.documentsAdded = [...filtered];
            this.resetFileData();

                this.ShowToast(
                "Proceso Exitoso",
                "El documento ha sido eliminado exitosamente.",
                "success"
                );
            }
        },
        async setEmptyDocument() {
            this.resetFileData();
            this.selectedEvaluation = null;
            this.addedEvaluations = [];
            this.noEvaluationsAdded = false;

            this.editableDocument = false;
            this.showUploadPanel = false;
        },
      resetFileData() {
        this.file.type = null;
        this.file.attachment = null;
        this.file.documentType = null;
        this.file.useSystemMinute = null;
        this.file.compuMinuteId = null;
        this.file.fileId = null;
        this.file.fileName = null;
      },
      async goToDraftMinute() {
        if (!this.evaluationDate) {
          this.ShowToast(
            "Alerta",
            "La fecha de la Determinación de Elegibilidad Trianual es requerida para redactar la minuta.",
            "error"
          );
          return;
        }

        const response = await compuMinuteService
          .getOrCreateDraftFromTriennialDetermination({
            studentSieId: Number(this.studentSieId),
            date: this.evaluationDate,
          })
          .catch((err) => {
            this.ShowToast(
              "Error",
              err?.response?.data?.message ||
                "No fue posible crear la minuta de COMPU.",
              "error"
            );
          });

        const id = response?.data?.id ?? response?.data;
        if (!id) return;

        this.$router.push(`/pei/compu-minutes-editor/${id}`);
      },
      onMinuteInputChange(data) {
        this.file = { ...this.file, ...data };
      },
      onMinuteDelete() {
        this.file.fileId = null;
        this.file.fileName = null;
        this.file.compuMinuteId = null;
        this.file.useSystemMinute = null;
      },
      async fetchParams() {
        const { data: sysParameters } = await getSysparameterByNames({
          parameterNames: ['ActiveCompuMinuteSystemSelection'],
        });
    
        this.sysParameters = sysParameters;
      },
      validDocumentDates() {
        let isValid = true;
        this.documentsAdded.forEach((element) => {
          if (!this.isValidMiunteDate(element.meetingDate)) {
            isValid = isValid && false;
          }
        });

        return isValid;
      },
      hasAtLeastOneDocument() {
        return this.documentsAdded.length > 0;
      },
      isValidMiunteDate(meetingDate) {
        if (!meetingDate || !this.evaluationDate) {
          return true;
        }

        // 1. Convertimos ambos valores a objetos Date reales
        const date1 = new Date(meetingDate);
        const date2 = new Date(this.evaluationDate);

        // 2. Validamos que ambas fechas sean válidas antes de comparar
        if (isNaN(date1) || isNaN(date2)) {
          return false;
        }

        // 3. Comparamos estrictamente año, mes y día
        return (
          date1.getFullYear() === date2.getFullYear() &&
          date1.getMonth() === date2.getMonth() &&
          date1.getDate() === date2.getDate()
        );
      },
    },
    async mounted() {
      await this.getDocumentTypes();
      this.setEmptyDocument();

      await this.fetchParams();
    },
    watch: {
      'file.useSystemMinute': {
        handler(newValue, oldValue) {
          if (oldValue === true && newValue === false) {
            this.toggleEdit();
            this.fileKey++;
          }
        },
      },
        currentDocuments: {
            deep: true,
            immediate: true,
            handler(newValue) {            
                newValue.forEach((element)=>{
                    this.documentsAdded.push({
                        documentName:element.documentName,
                        documentType:{name:element.documentTypeName},
                        documentId: element.documentId,
                    })
                });
            },
        },
    }
};
</script>

<style scoped lang="scss">
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.divider-vertical {
  border-bottom: 1px solid map.get($colors, "gray-5");
}

.divider-horizontal {
  border-right: 1px solid map.get($colors, "gray-5");
  margin-left: 50%;
  margin-right: 50%;
  height: 81%;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #b7c7bf;
}
.dropdown-item .cursor-pointer {
  border-bottom: 1px solid #e2e2e2;
}
.container-doc {
    background-color: #fafafa;
    border-radius: 5px;
}
.bg-gray {
  background: #f2f2f2;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.customChipPanel {
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.custom-dropDown-label ::v-deep {
  .data-name {
    font-size: 0.875rem !important;
  }
}
.custom-fileInput-label ::v-deep {
  .input-label {
    font-size: 0.875rem !important;
    font-weight: normal !important;
  }
}
.customChips-label ::v-deep {
  .chips-container p {
    font-size: 0.875rem !important;
    font-weight: normal !important;
  }
}
.resizer {
  width: 107%;
}
.evaluetion-unaviable {
  width: 100%;
}
.container-document-button {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 6px;
}
.container-upload-document {
  width: 100%;
  //margin-left: 100px;
}
.wrap-upload-panel {
  width: 101.5%;
  margin-left: -13px;
}
.upload-panel-container {
  width: 100%;
}

@media only screen and (min-width: 600px) {
  .resizer {
    width: 50%;
    margin-left: auto;
  }
  .container-upload-document {
    width: 50%;
    margin-left: 100px;
  }

  .align-button {
    position: relative;
    left: 66.5%;
  }

}
</style>
